export default __webpack_public_path__ + "static/media/grid.da72670d.svg";